import { KnowledgeHubResource } from "@/types/dto/category.dto";
import { MultiSelectDropdown, TMultiSelectDropdownItem } from "@/components/ui";
import { cn } from "@/lib/utils";
import { SearchIcon } from "lucide-react";
import { useRef, useState } from "react";
import KnowledgeHubCard from "./knowledge-hub-card";

const KnowledgeHubTab = ({ resources }: { resources?: KnowledgeHubResource[] }) => {
	const resourceTypeDropDownItems: TMultiSelectDropdownItem[] = [
		{ id: "article", name: "Article" },
		{ id: "video", name: "Video" },
		{ id: "file", name: "File" },
	];
	const searchRef = useRef<HTMLInputElement | null>(null);
	const [selectedResourceTypes, setSelectedResourceTypes] = useState<string[]>([]);

	const handleResourceTypeFilter = () => {
		setSelectedResourceTypes([]);
	};

	return (
		<div>
			<div className="my-8 flex flex-col gap-8 rounded-lg bg-white px-8 py-6 text-sm shadow-sm lg:flex-row lg:items-center lg:justify-between lg:gap-16">
				<div className="flex items-center gap-4">
					<span className="font-medium text-gray-600">Resource Type</span>
					<div className="w-full lg:w-40">
						<MultiSelectDropdown
							items={resourceTypeDropDownItems}
							selectedItems={selectedResourceTypes}
							setActiveItems={handleResourceTypeFilter}
							buttonLabel="All Status"
						/>
					</div>
				</div>

				<div>
					<div
						className={cn(
							"group flex w-full flex-1 items-center rounded border border-gray-200 bg-white px-4 py-2 lg:w-96",
							"transition-colors duration-150 ease-linear focus-within:border-brand-primary"
						)}
					>
						<span>
							<SearchIcon className="h-4 w-4 text-gray-400 transition-colors duration-150 ease-linear group-focus-within:text-blue-500" />
						</span>

						<input
							ref={searchRef}
							id="search"
							type="search"
							name="search"
							placeholder="Search"
							className="w-full px-2 text-sm focus:outline-none"
							onChange={(e) => console.log(e.target.value)}
						/>
					</div>
				</div>
			</div>

			<div className="flex flex-col">
				{resources && resources.length > 0 ? (
					resources?.map((resource) => (
						<KnowledgeHubCard
							key={resource.id}
							type={resource.type}
							title={resource.title}
							description={resource.description}
							thumbnail={resource.thumbnailSrc}
							link={resource?.link || "#"}
						/>
					))
				) : (
					<span>No resources found</span>
				)}
			</div>
		</div>
	);
};

export default KnowledgeHubTab;
